/*
 * @Author: pengzhihui
 * @Description:
 * @Date: 2020-04-24 18:40:24
 * @LastEditTime: 2021-06-11 14:58:08
 */
import { MicroAppEntryConfigs, MicroAppConfig, ConfigHandler } from "../interfaces";

export function appendStyle(href: string) {
    if (
        // 防止重复append
        [].slice.call(document.styleSheets).find((style: HTMLLinkElement) => {
            return style.href === href;
        })
    ) {
        return;
    }
    const link = document.createElement("link");
    link.setAttribute("type", "text/css");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", href);
    return document.head.appendChild(link);
}

export function insertCsss(config: MicroAppEntryConfigs, appIds: number[]) {
    return appIds.reduce((scElements: any[], appId: number) => {
        if (config[appId].cssEntry) {
            const appScElements = config[appId].cssEntry!.map((href: string) => {
                return appendStyle(href);
            });
            return [...scElements, ...appScElements];
        }
        return scElements;
    }, []);
}


export function getAppIdsByPath(configs: MicroAppEntryConfigs) {
    return Object.keys(configs).filter((appId) => {
        return new Function("location", configs[+appId].rule)(window.location);
    }).map(n => Number(n));
}

// 将配置写入localstorage
export function writeConfigToLocalstorage(config: MicroAppEntryConfigs, coreId: number): void {
    const host = window.location.host;
    window.localStorage &&
        window.localStorage.setItem(`${host}_${coreId}_dolly`, JSON.stringify(config));
}

// 获取localstorage
export function getConfigFromLocalstorage(): MicroAppEntryConfigs {
    const host = window.location.host;
    let config = null;
    try {
        const str = window.localStorage.getItem(`${host}_dolly`) || '{}';
        config = JSON.parse(str);
    } catch (e) {
        // log
    }
    return config;
}

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
);

export const isSlowNetwork = navigator.connection
    ? navigator.connection.saveData ||
      /(2|3)g/.test(navigator.connection.effectiveType)
    : false;

export const getMergedConfigs = (
    currentConfig: MicroAppEntryConfigs,
    additionConfig: MicroAppEntryConfigs,
    configHandler?: ConfigHandler
) => {
    if (Array.isArray(additionConfig)) {
        additionConfig.forEach((c) => {
            currentConfig[c.appId] = c;
        });
    } else {
        Object.keys(additionConfig).forEach((appId) => {
            currentConfig[Number(appId)] = additionConfig[Number(appId)];
        });
    }
    if (configHandler) {
        const handledConfig = configHandler(currentConfig);
        if (handledConfig) {
            return handledConfig;
        }
    }
    return currentConfig;
};

export const getContainerXpath = (container: string | HTMLElement): string | void => {
    const containerElement = getContainer(container);
    if (containerElement) {
      return getXPathForElement(containerElement, document);
    }
    return undefined;
};

/**
 * copy from https://developer.mozilla.org/zh-CN/docs/Using_XPath
 * @param el
 * @param document
 */
export function getXPathForElement(el: Node, document: Document): string | void {
    // not support that if el not existed in document yet(such as it not append to document before it mounted)
    if (!document.body.contains(el)) {
        return undefined;
    }
    let xpath = '';
    let pos;
    let tmpEle;
    let element = el;
    while (element !== document.documentElement) {
        pos = 0;
        tmpEle = element;
        while (tmpEle) {
            if (tmpEle.nodeType === 1 && tmpEle.nodeName === element.nodeName) {
                // If it is ELEMENT_NODE of the same name
                pos += 1;
            }
            tmpEle = tmpEle.previousSibling;
        }
        xpath = `*[name()='${element.nodeName}' and namespace-uri()='${
        element.namespaceURI === null ? '' : element.namespaceURI
        }'][${pos}]/${xpath}`;
        element = element.parentNode!;
    }

    xpath = `/*[name()='${document.documentElement.nodeName}' and namespace-uri()='${
        element.namespaceURI === null ? '' : element.namespaceURI
    }']/${xpath}`;
    xpath = xpath.replace(/\/$/, '');
    return xpath;
}

export function getContainer(container: string | HTMLElement): HTMLElement | null {
    return typeof container === 'string' ? document.querySelector(container) : container;
}